import { render, staticRenderFns } from "./TermsAndSpamPolicy.vue?vue&type=template&id=a7687202&scoped=true"
import script from "./TermsAndSpamPolicy.vue?vue&type=script&lang=js"
export * from "./TermsAndSpamPolicy.vue?vue&type=script&lang=js"
import style0 from "./TermsAndSpamPolicy.vue?vue&type=style&index=0&id=a7687202&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7687202",
  null
  
)

export default component.exports